import type { ChecklistType } from "../../../types/checklist/types";

const MINUTO = 60000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

export function calcularTempoTotal({ dia, hora, minuto }: { dia: number; hora: number; minuto: number }): number {
  return dia * DIA + hora * HORA + minuto * MINUTO;
}

export function converterMilissegundos(totalMs: number) {
  const dia = Math.floor(totalMs / DIA);
  const hora = Math.floor((totalMs % DIA) / HORA);
  const minuto = Math.floor((totalMs % HORA) / MINUTO);

  return { dia, hora, minuto };
}

export function handleChangeTempo(value: number, setValue: Function, tipo: "dia" | "hora" | "minuto") {
  setValue((prev: { dia: number; hora: number; minuto: number }) =>
    prev
      ? {
          ...prev,
          [tipo]: value,
        }
      : null,
  );
}

export function handleSetTempo(value: number, name: "tempoMaxPausa" | "tempoMaxExecucao", setValue: Function) {
  setValue((prev: ChecklistType) => {
    if (prev?.[name] === value) {
      return prev;
    }
    return {
      ...prev,
      [name]: value,
    };
  });
}

export function handleChangeDisparaChamadoPausado(event: React.ChangeEvent<HTMLInputElement>, setValue: Function) {
  setValue((prev: ChecklistType) =>
    prev
      ? {
          ...prev,
          disparaChamadoPausado: event.target.checked,
        }
      : null,
  );
}

export function handleChangeUsers(values: string[], name: "notificaPausa" | "retomaExec", setValue: Function) {
  setValue((prev: ChecklistType) =>
    prev
      ? {
          ...prev,
          [name]: values,
        }
      : null,
  );
}
